import { FC, ReactNode } from 'react'
import { ToneKey } from '../models'

interface Props {
  tone: ToneKey
  children: ReactNode
  className?: string
}

const TONE_CLS: Record<ToneKey, string> = {
  lila: 'bg-[#ede9fe] text-[#7c3aed]',
  rosa: 'bg-[#FAECE7] text-[#993C1D]',
  amber: 'bg-[#FEF3C7] text-[#92400E]',
  green: 'bg-[#EAF3DE] text-[#3B6D11]',
  blue: 'bg-[#E6F1FB] text-[#185FA5]',
  beige: 'bg-[#f5f5f4] text-[#78716c]',
  teal: 'bg-[#E0F2F1] text-[#0F766E]'
}

const Pill: FC<Props> = ({ tone, children, className = '' }) => (
  <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium ${TONE_CLS[tone]} ${className}`}>
    {children}
  </span>
)

export default Pill
